import React, { useState, useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import Image from "next/image";
import Link from 'next/link';
import blogimg1 from "../../public/images/blogimg1.png";
import logoeasycampus from "../../public/images/logo-easycampus.png";
import Blogsslider from './blogsslider';
import LatestarticalTitle from '@/components/latestarticle/latestarticaltitle';
import { getBlogDataApi } from '../action/easycampus';
import { capitalizeFirstLetter, dateFormatForUser } from '@/utils/common';
import LastBlog from './lastblog';



const Blogmainsection = () => {
  const [blogs, setBlogs] = useState([]);
  const currentRoute = usePathname("");
  let lastSegment = currentRoute.split("/").pop();
  

  // const decodeHtml = (html) => {
  //   var txt = document.createElement("textarea");
  //   txt.innerHTML = html;
  //   return txt.value;
  // };

  // function truncateHtml(html, maxLength) {
  //   const tempDiv = document.createElement("div");
  //   tempDiv.innerHTML = html;
  //   let truncated = "";
  //   let charCount = 0;
  //   let isTruncated = false; // Flag to check if content was truncated
  
  //   const traverseNodes = (node) => {
  //     if (charCount >= maxLength) {
  //       isTruncated = true; // Mark as truncated
  //       return;
  //     }
  
  //     if (node.nodeType === Node.TEXT_NODE) {
  //       const text = node.textContent;
  //       if (charCount + text.length > maxLength) {
  //         truncated += text.substring(0, maxLength - charCount);
  //         charCount = maxLength;
  //       } else {
  //         truncated += text;
  //         charCount += text.length;
  //       }
  //     } else if (node.nodeType === Node.ELEMENT_NODE) {
  //       truncated += `<${node.tagName.toLowerCase()}${
  //         node.getAttribute("style")
  //           ? ` style="${node.getAttribute("style")}"`
  //           : ""
  //       }>`;
  //       for (let i = 0; i < node.childNodes.length; i++) {
  //         traverseNodes(node.childNodes[i]);
  //         if (charCount >= maxLength) break;
  //       }
  //       truncated += `</${node.tagName.toLowerCase()}>`;
  //     }
  //   };
  
  //   for (let i = 0; i < tempDiv.childNodes.length; i++) {
  //     traverseNodes(tempDiv.childNodes[i]);
  //     if (charCount >= maxLength) break;
  //   }
  
  //   // Append "..." if truncated
  //   if (isTruncated) {
  //     truncated += "...";
  //   }
  
  //   return truncated;
  // }



  useEffect(() => {
    // Fetch blogs once on component mount
    getBlogs();
  }, []);
  

  

  const getBlogs = async () => {
    try {
    
      let blogData ={
        pageNo:1,
        pageSize:lastSegment==='blogs'?20:3
      }

      const response = await getBlogDataApi(blogData);
      if (response.data.hasError == false) {
        setBlogs(response.data.data);
        console.log("setCorporateCampusDetails", response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };



  return (
    <>
      <LastBlog blogs={blogs[0]} loading={false} />
      {blogs.length !== 0 && <Blogsslider blogDetails={blogs} />}
      <LatestarticalTitle count={2} />
    </>
  )
}


export default Blogmainsection